import Vue from "vue";
import Vuex from "vuex";
import Service from "../../../service/api.js";
import router from "../../../router/index.js";
import store from "@/store/store";

const ServerModule = {
    namespaced: true,
    state: {
        members : []
    },

    mutations: {
        members(state, obj) {
            state.members = obj;
        }
    },

    actions: {
        config({commit}, data) {
            Service.members('exp', data, {})
                .then((response) => {
                    store.commit("member/members", response.data.data)

                }).catch((err) => {
            });
        },
        create({commit}, data) {
            Service.members('post', data, {})
                .then((response) => {

                }).catch((err) => {
            });
        },
        update({commit}, data) {
            Service.members('put', data, {})
                .then((response) => {

                }).catch((err) => {
            });
        },
    },

    getters: {
        members(state, obj) {
            return state.members;
        },
    },
};

export default ServerModule;
